module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "sketch"
  }, [_c('ul', [_c('li', {
    staticClass: "entypo-credit-card"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("名称: ")]), _vm._v(_vm._s(_vm.content.name))]), _vm._v(" "), _c('li', {
    staticClass: "entypo-vcard"
  }, [_vm._v(_vm._s(_vm.content.introduction))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6542a5cf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/introduction.vue
// module id = 70
// module chunks = 0